import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Header } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import LoadInline from '../loading/LoadInline.js';
import {colors} from 'style';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    subtitle: {
        textAlign: 'center',
    },
    card: {
        overflow:'hidden',
        backgroundColor: '#fff',
    },
    iconHeader: {
        height:'42px', 
        padding:'10px 0px 0px 10px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    imageBanner: {
        height:'100%',
        width:'100%',
        backgroundSize:'cover',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundRepeat: 'no-repeat',
    },
    header: {
        fontSize: '1em',
        color:'#fff', 
    },
};

const Objectives = ({t, objectives, onClickObjective, getObjectiveImageUrl, busy}) => (
    <div className="full-height" style={style.content}>
        <Segment>
            <Header style={style.subtitle} size="tiny">{t('Select An Objective')} <Icon className='icon-chevron-down'/></Header>
            {busy && 
                <div style={style.loaderContainer}>
                    <LoadInline /> 
                </div>
            }
            {!busy && 
            <Card.Group>
            {objectives.map((objective)=>(
                        <Card key={objective.id} data-id={objective.id} style={style.card} onClick={()=>onClickObjective(objective.id)}>
                            <div style={style.iconHeader}>
                                <Icon size='large' className={'icon-myHealthSphere-logo'}></Icon> 
                                {objective.title}
                            </div>
                            <div style={{height:'240px'}}>
                                <div style={{...style.imageBanner, backgroundImage:Utils.url(getObjectiveImageUrl(objective))}}/>
                            </div>
                        </Card>
                    )
                )    
            }
            </Card.Group>
            }
        </Segment>
    </div>
);


export default translate('objectives')(Objectives);



// WEBPACK FOOTER //
// ./src/modules/objectives/Objectives.js